module.exports = __webpack_public_path__ + "img/vehicle-piaggio.b3176f62.png";